<div class="row pt-1 pb-2">
  <div class="col-12 ps-4">
    <nb-radio-group
      name="investmentsStatusFilter"
      class="filters-container"
      [(ngModel)]="investmentsStatusFilter"
      (click)="investmentsStatusFilterChanged()"
      >
      @for (option of investmentsStatusFilterOptions; track option) {
        <nb-radio [value]="option.value">
          {{ option.label }}
        </nb-radio>
      }
    </nb-radio-group>
  </div>
</div>
